import { ASSET_PREFIX } from "utils/constants";
import React from "react";
import GiftCardComponent from "components/gift-cards/GiftCardComponent";
import Link from "next/link";

const OrderPreview = ({ headingComponent, cardDesign, showFullGiftCardDetails = true, toName, toEmailAddress, fromName, message, durationInWeeks, withOrderCost }) => (
  <div className='paddedMaxWidthContainer' style={{ width: '90%', maxWidth: '600px', marginBottom: '3em' }}>
    { headingComponent }

    <div style={{ display: 'flex', width: '100%', justifyContent: 'center', fontWeight: 600 }}>
      <GiftCardComponent
        cardDesignImage={`${ASSET_PREFIX}/images/gift-cards/card-designs/${cardDesign}.jpg`}
        style={{
          margin: '0 1.5em 0 0',
          minWidth: '160px',
          maxWidth: '200px',
          height: 'auto',
          minHeight: '110px'
        }}
      />

      <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'center'}}>
        <p style={{ fontWeight: 'bold', fontSize: '1.1em', margin: 0 }}>
          Premium Subscription
        </p>

        { !showFullGiftCardDetails && (
          <p style={{ fontStyle: 'italic', marginTop: '0.2em', color: '#4A4A4A90', fontSize: '1.1em' }}>
            £{(durationInWeeks / 4) * 10}
          </p>
        )}

        { showFullGiftCardDetails && (
          <>
            <div className='separator' style={{ margin: '0.7em 0', width: '100%' }} />

            <p>
              { toName && toName.trim() !== '' &&
                <><strong>To</strong>: { toName } ({toEmailAddress})<br /></>
              }
              { fromName && fromName.trim() !== '' &&
                <><strong>From</strong>: { fromName }<br /></>
              }
            </p>

            { message && message.trim() !== '' &&
            <p>
              "{message}"
            </p>
            }
          </>
        )}

      </div>
    </div>

    <div className='separator' style={{ margin: '1.7em 0', width: '100%' }} />

    <div style={{ width: '100%', fontWeight: 600, fontStyle: 'italic', margin: '0 0 0.6em 0', fontSize: '1.1em' }}>
      <img src={`${ASSET_PREFIX}/images/gift-cards/entries-no-bg.svg`} style={{ float: 'left', marginRight: '0.8em', height: '22px' }} />
      {durationInWeeks} week subscription
    </div>

    <div style={{ width: '100%', fontWeight: 600, fontStyle: 'italic', fontSize: '1.1em' }}>
      <img src={`${ASSET_PREFIX}/images/gift-cards/trees-no-bg.svg`} style={{ float: 'left', marginRight: '0.8em', height: '22px' }} />
      {durationInWeeks} trees planted with {''}
      <Link href='/giving-back'>
        <a style={{ margin: 0, fontWeight: 800 }}>
          veritree
        </a>
      </Link>
      {''}
    </div>

    { withOrderCost &&
      <>
        <div className='separator' style={{ margin: '1.7em 0 1.2em 0', width: '100%' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.2em', width: '97%' }}>
          <h4 style={{ textAlign: 'left', margin: 0, fontSize: '1.2em' }}>
            TOTAL:
          </h4>
          <p style={{ margin: 0, fontWeight: 800, fontSize: '1.2em' }}>
            £{(durationInWeeks / 4) * 10}
          </p>
        </div>
      </>
    }
  </div>
);

export default OrderPreview;
